/**
 * Builds header nav from CMS siteSettings.navigation, filtering conditional items.
 */
export function buildNavigation(siteSettings, { graduateStudentsEnabled = false } = {}) {
  const raw = siteSettings?.navigation;
  if (!raw?.length) return null;

  const filterLink = (link) => {
    if (link.requiresGraduateStudentsEnabled && !graduateStudentsEnabled) return false;
    return true;
  };

  return raw.map((item) => {
    const dropdown = (item.dropdown || []).filter(filterLink).map((link) => ({
      label: link.label,
      path: link.path,
      external: !!link.external,
    }));

    return {
      label: item.label,
      path: item.path,
      external: !!item.external,
      dropdown: dropdown.length ? dropdown : undefined,
    };
  });
}
